import * as React from 'react';
import cn from 'classnames';
import { Dialog, DialogContentDrawerRenderProps, DialogSize } from '@economic/taco';
import { FormApi, AnyObject } from 'final-form';
import { ObjectSchema } from 'yup';
import { Calculation } from 'final-form-calculate';
import { t } from '~/app/shared/components/l10n/l10n';
import { LoadingBox } from '~/shared-ui';
import { Form } from '../../../../../shared/components/Form';
import SpinnerWithText, { LoadingTranslations } from '../../../../../shared/components/ui/SpinnerWithText/SpinnerWithText';

export interface SalesDialogFormProps {
    loading: boolean;
    loadingSpinnerWithText?: boolean;
    ariaLabel?: string;
    defaultOpen?: boolean;
    open?: boolean;
    onHide: () => void;
    className: string;
    drawer?: (formValues: AnyObject) => React.JSX.Element;
    extra?: React.ReactNode;
    children: (form: FormApi, drawer: DialogContentDrawerRenderProps, valid: boolean) => React.ReactNode;
    initialData: any;
    onSubmit: (values: any) => Promise<any> | void;
    validationSchema?: ((values: object) => ObjectSchema<{}>) | ObjectSchema<{}>;
    size?: DialogSize;
    updates?: ((context?: any) => Calculation[]) | Calculation[];
    loadingTranslations?: LoadingTranslations;
}

export function SalesDialogForm({
    loading,
    loadingSpinnerWithText,
    ariaLabel = '',
    defaultOpen,
    open,
    className,
    onHide,
    drawer,
    extra,
    children,
    initialData,
    onSubmit,
    validationSchema,
    size = 'xs',
    updates,
    loadingTranslations = undefined,
}: SalesDialogFormProps) {
    if (loading) {
        return (
            <Dialog defaultOpen={defaultOpen} open={open} onClose={onHide} size={size}>
                <Dialog.Content aria-label={t`TOAST_LOADING`} className={className}>
                    {loadingSpinnerWithText ? <SpinnerWithText loadingTranslations={loadingTranslations} /> : <LoadingBox />}
                </Dialog.Content>
            </Dialog>
        );
    }

    return (
        <Form
            initialData={initialData}
            onSubmit={onSubmit}
            validationSchema={validationSchema}
            updates={updates}
            skipNotifications>
            {({ form, values, valid }) => (
                <Dialog defaultOpen={defaultOpen} open={open} size={size} onClose={onHide}>
                    <Dialog.Content aria-label={ariaLabel} className={cn('form', drawer && 'h-xs', className)}>
                        {({ drawer: drawerProps }) => children(form, drawerProps ?? { open: false, toggle: () => {} }, valid)}
                    </Dialog.Content>
                    {extra && <Dialog.Extra>{extra}</Dialog.Extra>}
                    {drawer && <Dialog.Drawer>{drawer(values)}</Dialog.Drawer>}
                </Dialog>
            )}
        </Form>
    );
}
